<div class="t-popup popup-graphs" style='display: block;height:100%;'>

    <div class="popup-close"></div>
    
    <div class="popup-frame">
       
        <div class="patient-ob-box popup-body">
            
            <div class="h100 m-box" *ngIf="! isReports">

                <h2>Exam Search</h2>
                <div>
                    <strong style="margin-right: 0.5em;">
                        From:
                    </strong>
                    <input [matDatepicker]="startDatepicker" [(ngModel)]="startdate" [min]="searchmin"
                        class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()"
                        style="margin-right: 1em;">
                    <mat-datepicker #startDatepicker></mat-datepicker>
                    <strong style="margin-right: 0.5em;">
                        Until:
                    </strong>
                    <input [matDatepicker]="endDatepicker" [(ngModel)]="enddate" [max]="searchmax" (click)="endDatepicker.open()"
                        class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" style="margin-right: 1em;">
                    <mat-datepicker #endDatepicker></mat-datepicker>
                </div>
                <div class="h100 l-flex l-column">

                    <div class="l-fg1">

                        <div class="">
                            
                            <!-- new exam top (start) -->
                            <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                                
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="All" (click)="setVals('All')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        All
                                    </span>
                                </label>

                            
                              
                              
                                <label class="t-label-top" *ngIf="ls.isCardio">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Echo" (click)="setVals('Echo')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Echo
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.isCardio">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="ECG" (click)="setVals('ECG')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        ECG
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.isCardio">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Pneumology" (click)="setVals('Pneumology')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Pneumology
                                    </span>
                                </label>
                                
                                
                            </div>	
                            <!-- new exam top (end) -->
                            <div class="linked-radios-list linked-radios-set">
                                <ng-container *ngIf="etype == 'Echo'">
                                    <label class="linked-radios-item" (click)="setE($event,'TTE Adults')">
                                        <input type="checkbox" name="TTE Adults" [checked]="exams['TTE Adults']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">TTE Adults</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'TTE Pediatric')">
                                        <input type="checkbox" name="TTE Pediatric" [checked]="exams['TTE Pediatric']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">TTE Pediatric</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Stress-Echo')">
                                        <input type="checkbox" name="Stress-Echo" [checked]="exams['Stress-Echo']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Stress-Echo</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Duplex Carotid')">
                                        <input type="checkbox" name="Duplex Carotid" [checked]="exams['Duplex Carotid']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Duplex Carotid</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Stress')">
                                        <input type="checkbox" name="Stress" [checked]="exams['Stress']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Stress</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container>
                                <ng-container *ngIf="etype == 'ECG'">
                                    <label class="linked-radios-item" (click)="setE($event,'ECG')">
                                        <input type="checkbox" name="ECG" [checked]="exams['ECG']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">ECG</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Ergometry')">
                                        <input type="checkbox" name="Ergometry" [checked]="exams['Ergometry']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Ergometry</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Holter ECG')">
                                        <input type="checkbox" name="Holter ECG" [checked]="exams['Holter ECG']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Holter ECG</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container>
                                <ng-container *ngIf="etype == 'Pneumology'">
                                    <label class="linked-radios-item" (click)="setE($event,'Pulmonary functional assessment')">
                                        <input type="checkbox" name="Pulmonary functional assessment" [checked]="exams['Pulmonary functional assessment']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Pulmonary functional assessment</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Methacholine test')">
                                        <input type="checkbox" name="Methacholine test" [checked]="exams['Methacholine test']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Methacholine test</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container>                        
                                
                            </div>

                        </div>

                    </div>

                    <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">

                        <a class="btn-primary -exit" (click)="closed.emit(null)" style='padding-top: 1em;'>
                            Cancel
                        </a>
                        <button class="btn-primary -search"  (click)="search()" *ngIf="cansearch">
                            Search
                        </button>
                    </div>
                    
                </div>

            </div>
            <div class="h100 m-box" *ngIf="isReports">
                <h2 *ngIf="! ls.hasPremission('NoExams')">Exam Search</h2>
                <h2 *ngIf="ls.hasPremission('NoExams')">Maccabi Report</h2>
                <ng-container *ngIf="reportstype != 'Macabifin'">
                    From  <input [matDatepicker]="startDatepicker"  [(ngModel)]="startdate"  class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()">
                    <mat-datepicker #startDatepicker></mat-datepicker>
                    Until
                    <input [matDatepicker]="endDatepicker"  [(ngModel)]="enddate" (click)="endDatepicker.open()" class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP">
                    <mat-datepicker #endDatepicker></mat-datepicker>
                </ng-container>
                <div class="month-year-picker" *ngIf="reportstype == 'Macabifin'">
                    <label>Month:</label>
                    <select [(ngModel)]="selectedMonth" class="t-select t-field">
                        <option *ngFor="let m of months" [value]="m.value">{{m.name}}</option>
                    </select>
                    <label>Year:</label>
                    <select [(ngModel)]="selectedYear" class="t-select t-field">
                        <option *ngFor="let y of years" [value]="y">{{y}}</option>
                    </select>
                </div>
                <div class="h100 l-flex l-column">
                    <div class="l-fg1" *ngIf="! ls.hasPremission('NoExams')">
                        <div class="">
                            <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="AllReports" (click)="setVals('AllReports')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        All
                                    </span>
                                </label>
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="NotSigned" (click)="setVals('NotSigned')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Not signed
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.isAdmin">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="Refferelnum" (click)="setVals('Refferelnum')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Missing Refferel number
                                        <select class="t-field t-select" *ngIf="reportstype =='Refferelnum'" [(ngModel)]="hmostype">
                                            <option value="Macabi">מכבי</option>
                                            <option value="Leumit">לאומית</option>
                                            <option value="Meuhedet">מאוחדת</option>
                                            <option value="Clalit">כללית</option>
                                            <option value="Private">פרטי</option>
                                            <option value="IDF">צהל</option>
                                            <option value="null">לא שויכו</option>
                                        </select>
                                    </span>
                                </label>
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="HMO" (click)="setVals('HMO')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        BY HMO
                                        <select class="t-field t-select" *ngIf="reportstype =='HMO'" [(ngModel)]="hmostype">
                                            <option value="Macabi">מכבי</option>
                                            <option value="Leumit">לאומית</option>
                                            <option value="Meuhedet">מאוחדת</option>
                                            <option value="Clalit">כללית</option>
                                            <option value="Private">פרטי</option>
                                            <option value="IDF">צהל</option>
                                            <option value="null">לא שויכו</option>
                                        </select>
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.isAdmin || ls.finances">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="Macabi" (click)="setVals('Macabi')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Sent to Macabi
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.finances">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="Macabifin" (click)="setVals('Macabi')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Macabi financial report
                                    </span>
                                </label>

                            </div>
                            <div class="linked-radios-list linked-radios-set" *ngIf="false">
                           
                                <ng-container *ngIf="reportstype == 'HMO'">
                                    <label class="linked-radios-item" (click)="setE($event,'TTE Adults')">
                                        <input type="checkbox" name="TTE Adults" [checked]="exams['TTE Adults']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">TTE Adults</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Stress-Echo')">
                                        <input type="checkbox" name="Stress-Echo" [checked]="exams['Stress-Echo']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Stress-Echo</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Duplex Carotid')">
                                        <input type="checkbox" name="Duplex Carotid" [checked]="exams['Duplex Carotid']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Duplex Carotid</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Stress')">
                                        <input type="checkbox" name="Stress" [checked]="exams['Stress']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Stress</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container>
                                <!-- <ng-container *ngIf="etype == 'ECG'">
                                    <label class="linked-radios-item" (click)="setE($event,'ECG')">
                                        <input type="checkbox" name="ECG" [checked]="exams['ECG']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">ECG</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Ergometry')">
                                        <input type="checkbox" name="Ergometry" [checked]="exams['Ergometry']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Ergometry</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container> -->
                                
                                
                            </div>

                        </div>
                    </div>
                    <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">

                        <a class="patient-ob-btn -exit" (click)="closed.emit(null)" style='padding-top: 1em;'>
                            Cancel
                        </a>
                        <button class="patient-ob-btn -search"  (click)="search()" *ngIf="cansearch">
                            Search
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
